// src/services/cuestionariocatalog.js

// Catálogo maestro (labels para el doctor; keys son internas)
export const CATALOGO = {
  ginecologia: [
    { key: "ciclo_menstrual", tipo: "text", label: "Ciclo menstrual", placeholder: "Ingrese frecuencia y regularidad" },
    { key: "edad_menarca", tipo: "number", label: "Edad menarca", placeholder: "Edad en años" },
    { key: "fecha_ultima_menstruacion", tipo: "date", label: "Fecha última menstruación", placeholder: "AAAA-MM-DD" },
    { key: "vida_sexual", tipo: "text", label: "Vida sexual", placeholder: "Ingrese estado y número de parejas" },
    { key: "antecedentes_obstetricos", tipo: "textarea", label: "Antecedentes obstétricos", placeholder: "Describa antecedentes obstétricos" },
    { key: "antecedentes_reproductivos", tipo: "textarea", label: "Antecedentes reproductivos", placeholder: "Describa antecedentes reproductivos" },
    { key: "factores_riesgo_embarazo", tipo: "textarea", label: "Factores de riesgo en embarazo", placeholder: "Describa factores de riesgo" },
    { key: "fecha_ultimo_papanicolaou", tipo: "date", label: "Último papanicolaou", placeholder: "AAAA-MM-DD" },
    { key: "fecha_ultima_mastografia", tipo: "date", label: "Última mastografía", placeholder: "AAAA-MM-DD" },
    { key: "exploracion_gineco_obstetrica", tipo: "textarea", label: "Exploración gineco-obstétrica", placeholder: "Describa hallazgos" },
    { key: "fondo_uterino_cm", tipo: "number", label: "Fondo uterino (cm)", placeholder: "Ingrese cm" },
    { key: "movimientos_fetales", tipo: "text", label: "Movimientos fetales", placeholder: "Presente/Ausente; conteo" },
    { key: "frecuencia_cardiaca_fetal", tipo: "number", label: "Frecuencia cardiaca fetal (lpm)", placeholder: "Ingrese lpm" },
    { key: "otros_ginecologia", tipo: "textarea", label: "Otros (Ginecología)", placeholder: "Describa notas adicionales" },
  ],

  pediatria: [
    { key: "persona_responsable_paciente", tipo: "text", label: "Responsable del paciente", placeholder: "Nombre, relación y contacto" },
    { key: "esquema_vacunacion", tipo: "textarea", label: "Esquema de vacunación", placeholder: "Describa el esquema de vacunación" },
    { key: "tipo_parto", tipo: "select", label: "Tipo de parto", placeholder: "Seleccione" },
    { key: "peso_nacer", tipo: "number", label: "Peso al nacer (kg)", placeholder: "Ingrese kg" },
    { key: "talla_nacer", tipo: "number", label: "Talla al nacer (cm)", placeholder: "Ingrese cm" },
    { key: "perimetro_cefalico_nacer", tipo: "number", label: "Perímetro cefálico al nacer (cm)", placeholder: "Ingrese cm" },
    { key: "antecedentes_perinatales", tipo: "textarea", label: "Antecedentes perinatales", placeholder: "Describa antecedentes perinatales" },
    { key: "hitos_desarrollo", tipo: "textarea", label: "Hitos del desarrollo", placeholder: "Describa hitos del desarrollo por edad" },
    { key: "perimetro_cefalico", tipo: "number", label: "Perímetro cefálico actual (cm)", placeholder: "Ingrese cm" },
    { key: "es_longitud", tipo: "boolean", label: "Longitud (paciente no se puede sostener de pie)", placeholder: "Marca si aplica" },
    { key: "longitud", tipo: "number", label: "Longitud (cm)", placeholder: "Ingrese cm" },
    //{ key: "peso_percentil", tipo: "number", label: "Peso (percentil)", placeholder: "Ingrese percentil" },
    //{ key: "talla_percentil", tipo: "number", label: "Talla (percentil)", placeholder: "Ingrese percentil" },
    //{ key: "perimetro_cefalico_percentil", tipo: "number", label: "Perímetro cefálico (percentil)", placeholder: "Ingrese percentil" },
    //{ key: "peso_talla_percentil", tipo: "number", label: "Peso/Talla (percentil)", placeholder: "Ingrese percentil" },
    {  key: "otros_pediatria", tipo: "textarea", label: "Otros (Pediatría)", placeholder: "Describa notas adicionales" },
  ],

  geriatria: [
    { key: "enfermedades_cronicas", tipo: "textarea", label: "Enfermedades crónicas", placeholder: "Describa enfermedades crónicas" },
    { key: "apoyo_familiar", tipo: "text", label: "Apoyo familiar", placeholder: "Describa red y apoyos disponibles" },
    { key: "dispositivos_movilidad", tipo: "text", label: "Dispositivos de movilidad", placeholder: "Describa dispositivos utilizados" },
    { key: "caidas_ultimos_12_meses", tipo: "boolean", label: "Caídas últimos 12 meses", placeholder: "Marca si aplica" },
    { key: "detalle_caidas_12_meses", tipo: "textarea", label: "Detalle de caídas en los últimos 12 meses", placeholder: "Describa número, fechas, contexto y lesiones (si aplica)" },
    { key: "dependencia_aseo_personal", tipo: "boolean", label: "Dependencia en aseo personal", placeholder: "Marca si aplica" },
    { key: "esquema_vacunacion_geriatria", tipo: "boolean", label: "Esquema de vacunación al día", placeholder: "Marca si aplica" },
    { key: "otros_geriatria", tipo: "textarea", label: "Otros (Geriatría)", placeholder: "Describa notas adicionales" },
  ],
};

export const ESPECIALIDADES = ["ginecologia", "pediatria", "geriatria"];

// ============================================================
// VARIABLES NOM-024 — GENERALES
// ============================================================
// Se muestran siempre que NOM-024 esté activo.
// No dependen de especialidad, edad, sexo ni selected_keys.
// ============================================================

export const PREGUNTAS_NOM24_GENERALES = [
  {
    key: "numeroSobresVSOPromocion",
    tipo: "select",
    label: "Número de sobres Vida Suero Oral en promoción",
    options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    labels: {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9"
    }
  },
  {
    key: "cartillaSalud",
    tipo: "select",
    label: "¿Presenta cartilla de salud?",
    options: [0, 1],
    labels: {
      0: "No",
      1: "Sí"
    }
  }
];
  
  // ============================================================
  // VARIABLES NOM-024 — GERONTOLOGÍA
  // ============================================================
  // IMPORTANTE:
  // Estas variables NO forman parte del catálogo clínico normal.
  // NO dependen de especialidad.
  // NO dependen de selected_keys.
  // NO dependen de configuraciones del médico.
  //
  // Estas preguntas se muestran ÚNICAMENTE si cumplen reglas NOM
  // (ej. edad ≥ 60) evaluadas en elegibilidad.js
  //
  // El render se controla desde:
  // CuestionarioPorEspecialidadHistoria.js
  //
  // Estas preguntas son obligatorias para exportación NOM-024.
  // ============================================================

  export const PREGUNTAS_NOM24_GERONTOLOGIA = [
    {
      key: "sintomaDepresiva",
      tipo: "select",
      label: "Sintomatología depresiva",
      options: [1,2],
      labels: {
        1: "Preventiva",
        2: "Tratamiento"
      }
    },
    {
      key: "alteracionMemoria",
      tipo: "select",
      label: "Alteración de memoria",
      options: [1, 2],
      labels: {
        1: "Preventiva",
        2: "Tratamiento"
      }
    },
    {
      key: "aivdABVD",
      tipo: "select",
      label: "Actividades de la vida diaria (AIVD / ABVD)",
      options: [1, 2],
      labels: {
        1: "Preventiva",
        2: "Tratamiento"
      }
    },
    {
      key: "sindromeCaidas",
      tipo: "select",
      label: "Síndrome de caídas",
      options: [1, 2],
      labels: {
        1: "Preventiva",
        2: "Tratamiento"
      }
    },
    {
      key: "incontinenciaUrinaria",
      tipo: "select",
      label: "Incontinencia urinaria",
      options: [1, 2],
      labels: {
        1: "Preventiva",
        2: "Tratamiento"
      }
    },
    {
      key: "motricidad",
      tipo: "select",
      label: "Motricidad",
      options: [1, 2],
      labels: {
        1: "Preventiva",
        2: "Tratamiento"
      }
    },
    {
      key: "asesoriaNutricional",
      tipo: "select",
      label: "Asesoría nutricional en adulto mayor",
      options: [1, 2],
      labels: {
        1: "Preventiva",
        2: "Tratamiento"
      }
    },
  ];

// ============================================================
// VARIABLES NOM-024 — SALUD MATERNA
// ============================================================


  export const PREGUNTAS_NOM24_SALUD_MATERNA = [{
    key: "atencionPregestacionalRT",
    tipo: "select",
    label: "Atención pregestacional",
    options: [0,1],
    labels: {
      0: "Primera vez",
      1: "Subsecuente"
    }
  },

  {
    key: "riesgo",
    tipo: "multiselect",
    label: "Riesgos detectados en atención pregestacional (puede ser más de 1)",
    options: [1, 2, 3, 4, 5, 9],
    labels: {
      1: "Patología crónica órgano funcional",
      2: "Patología crónica infecciosa",
      3: "Morbilidad materna extrema",
      4: "Con factores de riesgo sociales",
      5: "Antecedentes obstétricos de riesgo",
      9: "Sin antecedentes"
    }
  },

  {
    key: "relacionTemporalEmbarazo",
    tipo: "select",
    label: "Relación temporal del embarazo",
    options: [0,1],
    labels: {
      0: "Primera vez",
      1: "Subsecuente"
    }
  },

  {
    key: "trimestreGestacional",
    tipo: "select",
    label: "Trimestre gestacional",
    options: [1,2,3],
    labels: {
      1: "Primero",
      2: "Segundo",
      3: "Tercero"
    }
  },

  {
    key: "primeraVezAltoRiesgo",
    tipo: "select",
    label: "Primera vez con embarazo de alto riesgo",
    options: [0,1],
    labels: {
      0: "No",
      1: "Sí"
    }
  },

  {
    key: "complicacionPorDiabetes",
    tipo: "select",
    label: "Complicación por diabetes mellitus",
    options: [0,1],
    labels: {
      0: "No",
      1: "Sí"
    }
  },

  {
    key: "complicacionPorInfeccionUrinaria",
    tipo: "select",
    label: "Complicación por infección urinaria",
    options: [0,1],
    labels: {
      0: "No",
      1: "Sí"
    }
  },

  {
    key: "complicacionPorPreeclampsiaEclampsia",
    tipo: "select",
    label: "Complicación por preeclampsia o eclampsia",
    options: [0,1],
    labels: {
      0: "No",
      1: "Sí"
    }
  },

  {
    key: "complicacionPorHemorragia",
    tipo: "select",
    label: "Complicación por hemorragia",
    options: [0,1],
    labels: {
      0: "No",
      1: "Sí"
    }
  },

  {
    key: "hipertensionarterialprexistente",
    tipo: "select",
    label: "Hipertensión arterial preexistente",
    options: [0,1],
    labels: {
      0: "No",
      1: "Sí"
    }
  },

  {
    key: "otrasAccPrescAcidoFolico",
    tipo: "select",
    label: "Prescripción de ácido fólico",
    options: [0,1],
    labels: {
      0: "No",
      1: "Sí"
    }
  },

  {
    key: "otrasACCApoyoTransladoAME",
    tipo: "select",
    label: "Apoyo de traslado AME",
    options: [0,1],
    labels: {
      0: "No",
      1: "Sí"
    }
  },

  {
    key: "puerpera",
    tipo: "select",
    label: "Paciente puérpera",
    options: [0,1],
    labels: {
      0: "Primera vez",
      1: "Subsecuente"
    }
  },

  {
    key: "infeccionPuerperal",
    tipo: "select",
    label: "Infección puerperal",
    options: [0,1],
    labels: {
      0: "Primera vez",
      1: "Subsecuente"
    }
  }
  ];

  // ============================================================
  // VARIABLES NOM-024 — PEDIATRÍA
  // ============================================================

  export const PREGUNTAS_NOM24_PEDIATRIA = [
    {
      key: "ninoSanoRT",
      tipo: "select",
      label: "Consulta a niño sano",
      options: [0,1],
      labels: {
        0: "Primera vez",
        1: "Subsecuente"
      }
    },

    {
      key: "pruebaEDI",
      tipo: "select",
      label: "Aplicación de prueba EDI",
      options: [1,2],
      labels: {
      1: "Inicial",
        2: "Subsecuente"
      }
    },

    {
      key: "resultadoEDI",
      tipo: "select",
      label: "Resultado prueba EDI",
      options: [1,2,3,4,5,6],
      labels: {
        1: "Verde",
        2: "Amarillo",
        3: "Rojo",
        4: "Recuperado de rezago",
        5: "Recuperado de riesgo de retraso",
        6: "En seguimiento"
         },
      opcionesPorDependencia: {
        dependeDe: "pruebaEDI",
        mapa: {
          "1": [1, 2, 3],
          "2": [4, 5, 6]
        }
      }
    },

    {
      key: "resultadoBattelle",
      tipo: "select",
      label: "Resultado prueba Battelle",
      options: [1,2,3],
      labels: {
        1: "Mayor o igual a 90",
        2: "De 89 a 80",
        3: "Menor o igual a 79"
      }
    },

    {
      key: "edasRT",
      tipo: "select",
      label: "Enfermedad diarreica aguda (EDA)",
      options: [0,1],
      labels: {
        0: "Primera vez",
        1: "Subsecuente"
      }
    },

    {
      key: "edasPlanTratamiento",
      tipo: "select",
      label: "Plan de tratamiento EDA",
      options: [1,2,3],
      labels: {
        1: "Plan A",
        2: "Plan B",
        3: "Plan C"
      }
    },

    {
      key: "recuperadoDeshidratacion",
      tipo: "select",
      label: "Recuperación de deshidratación",
      options: [0,1],
      labels: {
        0: "No",
        1: "Sí"
      }
    },

    {
      key: "irasRT",
      tipo: "select",
      label: "Infección respiratoria aguda (IRA)",
      options: [0,1],
      labels: {
        0: "Primera vez",
        1: "Subsecuente"
      }
    },

    {
      key: "irasPlanTratamiento",
      tipo: "select",
      label: "Plan de tratamiento IRA",
      options: [1,2],
      labels: {
        1: "Sintomático",
        2: "Antibiótico"
      }
    },

    {
      key: "neumoniaRT",
      tipo: "select",
      label: "Neumonía",
      options: [0,1],
      labels: {
        0: "Primera vez",
        1: "Subsecuente"
      }
    }
  ];

export const keysDe = (esp) => (CATALOGO[esp] || []).map((q) => q.key);

// util para mostrar el chip de especialidad de una pregunta
export const especialidadDeKey = (key) =>
  ESPECIALIDADES.find((e) => (CATALOGO[e] || []).some((q) => q.key === key)) || null;

// normaliza strings libres (“Geriatría”, “GINE”, etc.) a nuestras 3 claves
export const normalizeEspecialidad = (s) => {
  const x = (s || "").toLowerCase();
  if (x.includes("gine")) return "ginecologia";
  if (x.includes("pedi")) return "pediatria";
  if (x.includes("geri")) return "geriatria";
  return null;
};

// === Catálogo para Consulta de seguimiento (según modelo) ===
export const CATALOGO_CONSULTA = {
  ginecologia: [
    { key: "exploracion_gineco_obstetrica", tipo: "textarea", label: "Exploración gineco-obstétrica", placeholder: "Describa hallazgos" },
    { key: "fondo_uterino_cm", tipo: "number", label: "Fondo uterino (cm)", placeholder: "Ingrese cm"   },
    { key: "movimientos_fetales", tipo: "text", label: "Movimientos fetales", placeholder: "Presente/Ausente; conteo" },
    { key: "frecuencia_cardiaca_fetal", tipo: "number", label: "FCF (lpm)", placeholder: "Ingrese lpm" },
    { key: "otros_ginecologia", tipo: "textarea", label: "Otros (Ginecología)", placeholder: "Describa notas adicionales"  }, // siempre al final
  ],
  pediatria: [
    { key: "hitos_desarrollo", tipo: "textarea", label: "Hitos del desarrollo", placeholder: "Describa hitos del desarrollo por edad" },
    { key: "perimetro_cefalico", tipo: "number", label: "Perímetro cefálico (cm)", placeholder: "Ingrese cm"  },
    { key: "es_longitud", tipo: "boolean", label: "¿Usar longitud (no talla)?"  },
    { key: "longitud", tipo: "number", label: "Longitud (cm)" },
    //{ key: "peso_percentil", tipo: "number", label: "Peso (percentil)",  placeholder: "Ingrese percentil"  },
    //{ key: "talla_percentil", tipo: "number", label: "Talla (percentil)", placeholder: "Ingrese percentil"  },
    //{ key: "perimetro_cefalico_percentil", tipo: "number", label: "Perímetro cefálico (percentil)" , placeholder: "Ingrese percentil"},
    //{ key: "peso_talla_percentil", tipo: "number", label: "Peso/Talla (percentil)" , placeholder: "Ingrese percentil"},
    { key: "otros_pediatria", tipo: "textarea", label: "Otros (Pediatría)", placeholder: "Describa notas adicionales" }, // al final
  ],
  geriatria: [
    { key: "caidas_ultimos_12_meses", tipo: "boolean", label: "Caída desde última consulta" },
    { key: "detalle_caidas_12_meses", tipo: "textarea", label: "Detalle de caídas desde última consulta", placeholder: "Describa número, fechas, contexto y lesiones (si aplica)" },
    { key: "dependencia_aseo_personal", tipo: "boolean", label: "Dependencia en aseo personal" },
    { key: "otros_geriatria", tipo: "textarea", label: "Otros (Geriatría)", placeholder: "Describa notas adicionales" }, // al final
  ],
};

// helpers (opcional, por consistencia)
export const keysDeConsulta = (esp) =>
  Array.isArray(CATALOGO_CONSULTA[esp]) ? CATALOGO_CONSULTA[esp].map((q) => q.key) : [];

export const especialidadDeKeyConsulta = (key) =>
  ESPECIALIDADES.find((e) => (CATALOGO_CONSULTA[e] || []).some((q) => q.key === key)) || null;


